module.exports = __webpack_public_path__ + "img/63.10.TU.ee87d50e.png";